import { render, staticRenderFns } from "./certificateData.vue?vue&type=template&id=48203879&"
import script from "./certificateData.vue?vue&type=script&lang=js&"
export * from "./certificateData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports